import { getVirtualReferrerFromLocationState } from '@web-platform/shared-universal-utils-frontend/src/helpers/getLocationState';
import { historyLocation } from '@web-platform/shared-universal-utils-frontend/src/history';

import type { InitialLocationState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/initialLocation';
import type { Location } from 'react-router-dom';

const storedVirtualReferrer = (location: Location) => {
  const lastVirtualReferrer = getVirtualReferrerFromLocationState(location);
  return lastVirtualReferrer != null ? lastVirtualReferrer : '';
};

export const getInitialLocation = (): InitialLocationState => ({
  ...historyLocation,
  lastNavWasSoft: false,
  virtualReferrer: storedVirtualReferrer(historyLocation),
});

export default function (state: InitialLocationState = getInitialLocation()) {
  return state;
}
export const get = (state: InitialLocationState) => state;
